<script>
  import { openModal } from 'svelte-modals';
  import { language } from '../stores/languageStore.js';
  import { getCurrentLanguage, t, translateText } from '../services/translation/translationService.js';
  import LanguageOptionsModal from './modals/LanguageOptionsModal.svelte';

  let selectedLanguage = $language;

  const languages = [
    {code: 'en', name: 'English'},
    {code: 'fr', name: 'Français'},
    {code: 'es', name: 'Español'},
    {code: 'de', name: 'Deutsch'},
    {code: 'el', name: 'Ελληνικά'},
    {code: 'pl', name: 'Polski'},
    {code: 'ro', name: 'Română'},
    {code: 'hu', name: 'Magyar'},
    {code: 'bg', name: 'Български'},
    {code: 'hr', name: 'Hrvatski'},
    {code: 'ar', name: 'العربية'},
    {code: 'ko', name: '한국어'}
  ];

  function openLanguageModal() {
    openModal(LanguageOptionsModal, {
      languages,
      onSelect: handleLanguageChange,
    });
  }

  async function handleLanguageChange(lang) {
    const currentLang = getCurrentLanguage();
    if (lang !== currentLang) {
      language.set(lang);
      Object.keys($t).forEach(async (key) => {
        const translatedText = await translateText($t[key], currentLang, lang);
        $t[key] = translatedText;
      });
      selectedLanguage = lang;
    }
  }

  function handleKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      openLanguageModal();
    }
  }

</script>

<style>
  .language-selector {
    position: relative;
    user-select: none;
  }

  .selected-language {
    background-color: #003476;
    color: #ffffff;
    padding: 10px;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 60px;
  }


</style>

<div class="language-selector">
  <div aria-haspopup="true"
       class="selected-language"
       on:click={openLanguageModal}
       on:keydown={handleKeydown}
       role="button"
       tabindex="0">
    {$language.toUpperCase()} ▼
  </div>

</div>
